<form [formGroup]="directContentService.form">
  <div>
    <label class="text-sm text-left font-bold block text-night" for="title">Hero title</label>
    <mat-form-field class="w-full">
      <input matInput type="text" formControlName="title" />
    </mat-form-field>
  </div>

  <div>
    <label class="text-sm text-left font-bold block text-night" for="subtitle">Hero subtitle</label>
    <mat-form-field class="w-full">
      <input matInput type="text" formControlName="subtitle" />
    </mat-form-field>
  </div>
</form>
